import { sum, map, filter, uniqBy } from "lodash";
import axios from "src/utils/axios";
import { axios as ax } from "axios";
import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  restaurant_ok: false,
  mesa_ok: false,
  ok: false,
  id_restaurante: "",
  id_mesa: "",
};

const slice = createSlice({
  name: "configuration",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    configurationOk(state, action) {
      state.isLoading = false;
      state.restaurant_ok = true;
      state.mesa_ok = true;
      state.ok = true;
      state.id_restaurante = action.payload.idRestaurante;
      state.id_mesa = action.payload.idMesa;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { configurationOk } = slice.actions;

// ----------------------------------------------------------------------

export function checkConfiguration(idRestaurante, idMesa) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("configurationCarta", {
        params: {
          idRestaurante,
          idMesa,
        },
      });
      dispatch(slice.actions.configurationOk({ idRestaurante, idMesa }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
